import { tuple } from '@sravni/react-utils';
import { SPACE_SIZES } from '../../../constants/spaces.js';

tuple('horizontal', 'vertical', 'row-reverse', 'column-reverse', 'row', 'column');
tuple('start', 'end', 'center', 'baseline', 'stretch', 'flex-start', 'flex-end');
tuple('start', 'end', 'center', 'space-between', 'space-around', 'stretch', 'flex-start', 'flex-end');
const EXTRA_SPACE_SIZES = {
    S48: 48,
    S60: 60,
};
const SIZES = { ...EXTRA_SPACE_SIZES, ...SPACE_SIZES };

export { SIZES };
//# sourceMappingURL=Space.types.js.map
